/* AL FAJR theme — vanilla, no dependencies. */
(function init() {
  "use strict";
  // Everything below queries the DOM at load time; if the script is ever inlined in
  // <head> (defer is a no-op on inline scripts) wait for the body first.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
    return;
  }

  var T = window.theme || {};
  var money = function (cents) {
    var fmt = T.moneyFormat || "€{{amount}}";
    var value = (cents / 100).toFixed(2);
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/, value.replace(".", ","))
      .replace(
        /\{\{\s*amount_with_comma_separator\s*\}\}/,
        value.replace(".", ","),
      )
      .replace(
        /\{\{\s*amount_no_decimals\s*\}\}/,
        String(Math.round(cents / 100)),
      );
  };

  /* ---------------- drawers ---------------- */

  var lastFocus = null;

  function openDrawer(id) {
    var el = document.getElementById(id);
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    // force a frame so the transform transition runs
    requestAnimationFrame(function () {
      el.classList.add("is-open");
    });
    document.body.classList.add("is-locked");
    var focusable = el.querySelector("input, button, a[href]");
    if (focusable) focusable.focus();
  }

  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove("is-open");
    document.body.classList.remove("is-locked");
    window.setTimeout(function () {
      el.hidden = true;
    }, 460);
    if (lastFocus) lastFocus.focus();
  }

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-drawer-open]");
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute("data-drawer-open"));
      return;
    }
    var closer = e.target.closest("[data-drawer-close]");
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest("[data-drawer]"));
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var open = document.querySelector("[data-drawer].is-open");
    if (open) closeDrawer(open);
  });

  /* focus trap inside an open drawer */
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Tab") return;
    var open = document.querySelector("[data-drawer].is-open .drawer__panel");
    if (!open) return;
    var items = open.querySelectorAll(
      'a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])',
    );
    if (!items.length) return;
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------------- header height token ---------------- */

  var header = document.querySelector("[data-header]");
  function syncHeader() {
    if (!header) return;
    document.documentElement.style.setProperty(
      "--header-h",
      header.offsetHeight + "px",
    );
  }
  syncHeader();
  window.addEventListener("resize", syncHeader);

  /* ---------------- scroll reveal ---------------- */

  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-in");
          io.unobserve(entry.target);
        });
      },
      { rootMargin: "0px 0px -8% 0px", threshold: 0.05 },
    );
    document.querySelectorAll("[data-reveal]").forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll("[data-reveal]").forEach(function (el) {
      el.classList.add("is-in");
    });
  }

  /* ---------------- quantity steppers ---------------- */

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty-step]");
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest("[data-qty]");
    var input = wrap && wrap.querySelector("input");
    if (!input) return;
    var min = parseInt(input.min || "1", 10);
    var next =
      (parseInt(input.value, 10) || min) +
      parseInt(btn.getAttribute("data-qty-step"), 10);
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  /* ---------------- cart ---------------- */

  function refreshCartUI(cart) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    updateShipBar(cart.total_price);
    // re-render the drawer body from the cart section
    fetch(T.routes.cart_url + "?section_id=cart-drawer")
      .then(function (r) {
        return r.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-cart-drawer-content]");
        var target = document.querySelector("[data-cart-drawer-content]");
        if (fresh && target) target.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function updateShipBar(totalPrice) {
    var threshold = T.freeShippingThreshold || 0;
    document.querySelectorAll("[data-ship-bar]").forEach(function (bar) {
      if (!threshold) {
        bar.hidden = true;
        return;
      }
      bar.hidden = false;
      var pct = Math.min(100, (totalPrice / threshold) * 100);
      var fill = bar.querySelector("[data-ship-fill]");
      var text = bar.querySelector("[data-ship-text]");
      if (fill) fill.style.width = pct + "%";
      if (!text) return;
      if (totalPrice >= threshold) {
        text.innerHTML = T.strings.shipQualified;
      } else {
        text.innerHTML = (T.strings.shipRemaining || "").replace(
          "[amount]",
          "<b>" + money(threshold - totalPrice) + "</b>",
        );
      }
    });
  }

  function cartFetch(url, body) {
    return fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(body),
    }).then(function (r) {
      return r.json();
    });
  }

  /* add to cart (any form with data-cart-form) */
  document.addEventListener("submit", function (e) {
    var form = e.target.closest("form[data-cart-form]");
    if (!form || T.cartDrawer === "page") return;
    e.preventDefault();

    var btn = form.querySelector('[type="submit"]');
    var label = btn ? btn.textContent : "";
    if (btn) {
      btn.disabled = true;
      btn.textContent = "…";
    }
    var errorEl = form.querySelector("[data-cart-error]");
    if (errorEl) errorEl.textContent = "";

    var data = new FormData(form);
    var items = [];
    // support several id[]/quantity[] pairs (bundle add-all)
    var ids = data.getAll("id");
    var qtys = data.getAll("quantity");
    ids.forEach(function (id, i) {
      if (!id) return;
      items.push({ id: Number(id), quantity: Number(qtys[i] || qtys[0] || 1) });
    });

    cartFetch(T.routes.cart_add_url, { items: items })
      .then(function (res) {
        if (res.status && res.status !== 200)
          throw new Error(res.description || res.message);
        return fetch(T.routes.cart_url + ".js").then(function (r) {
          return r.json();
        });
      })
      .then(function (cart) {
        refreshCartUI(cart);
        openDrawer("CartDrawer");
      })
      .catch(function (err) {
        if (errorEl) errorEl.textContent = err.message;
      })
      .finally(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = label;
        }
      });
  });

  /* line changes inside the cart drawer / cart page */
  document.addEventListener("click", function (e) {
    var remove = e.target.closest("[data-line-remove]");
    if (!remove) return;
    e.preventDefault();
    changeLine(remove.getAttribute("data-line-remove"), 0);
  });

  document.addEventListener("change", function (e) {
    var input = e.target.closest("[data-line-qty]");
    if (!input) return;
    changeLine(
      input.getAttribute("data-line-qty"),
      parseInt(input.value, 10) || 0,
    );
  });

  function changeLine(line, quantity) {
    cartFetch(T.routes.cart_change_url, {
      line: Number(line),
      quantity: quantity,
    }).then(function (cart) {
      refreshCartUI(cart);
      if (document.body.classList.contains("template-cart"))
        window.location.reload();
    });
  }

  /* ---------------- product gallery ---------------- */

  document.addEventListener("click", function (e) {
    var thumb = e.target.closest("[data-media-thumb]");
    if (!thumb) return;
    e.preventDefault();
    var gallery = thumb.closest("[data-gallery]");
    if (!gallery) return;
    var id = thumb.getAttribute("data-media-thumb");
    gallery.querySelectorAll("[data-media-item]").forEach(function (item) {
      item.hidden = item.getAttribute("data-media-item") !== id;
    });
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-media-thumb]"),
    );
    thumbs.forEach(function (t) {
      t.setAttribute("aria-current", String(t === thumb));
    });
    var counter = gallery.querySelector("[data-media-counter]");
    if (counter)
      counter.textContent = thumbs.indexOf(thumb) + 1 + " / " + thumbs.length;
  });

  /* arrows just move the selection along the thumb list */
  document.addEventListener("click", function (e) {
    var nav = e.target.closest("[data-media-nav]");
    if (!nav) return;
    e.preventDefault();
    var gallery = nav.closest("[data-gallery]");
    if (!gallery) return;
    var thumbs = Array.prototype.slice.call(
      gallery.querySelectorAll("[data-media-thumb]"),
    );
    if (!thumbs.length) return;
    var current = thumbs.findIndex(function (t) {
      return t.getAttribute("aria-current") === "true";
    });
    if (current < 0) current = 0;
    var step = Number(nav.getAttribute("data-media-nav")) || 1;
    var next = (current + step + thumbs.length) % thumbs.length;
    thumbs[next].click();
  });

  /* ---------------- variant picker ---------------- */

  document.querySelectorAll("[data-product-form]").forEach(function (root) {
    var dataEl = root.querySelector("[data-variants]");
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = root.querySelector("[data-variant-id]");
    var priceScope = root.closest(".shopify-section") || document;
    var priceEls = priceScope.querySelectorAll("[data-price]");
    var submit = root.querySelector("[data-add-button]");
    var sku = root.querySelector("[data-sku]");

    function selected() {
      return Array.from(root.querySelectorAll("[data-option-index]"))
        .filter(function (i) {
          return i.checked || i.tagName === "SELECT";
        })
        .map(function (i) {
          return i.value;
        });
    }

    function apply() {
      var chosen = selected();
      var match = variants.find(function (v) {
        return v.options.every(function (opt, i) {
          return opt === chosen[i];
        });
      });

      root.querySelectorAll("[data-option-name]").forEach(function (label) {
        var idx = Number(label.getAttribute("data-option-name"));
        var current = label.querySelector("b");
        if (current && chosen[idx]) current.textContent = chosen[idx];
      });

      if (!match) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = T.strings.unavailable;
        }
        return;
      }

      if (idInput) idInput.value = match.id;
      var priceHtml =
        '<span class="' +
        (match.compare_at_price > match.price ? "price price--sale" : "price") +
        '">' +
        money(match.price) +
        "</span>" +
        (match.compare_at_price > match.price
          ? '<span class="price__was">' +
            money(match.compare_at_price) +
            "</span>"
          : "");
      priceEls.forEach(function (el) {
        el.innerHTML = priceHtml;
      });
      if (sku) sku.textContent = match.sku || "";
      if (submit) {
        submit.disabled = !match.available;
        var label = match.available ? T.strings.addToCart : T.strings.soldOut;
        if (match.available && submit.hasAttribute("data-atc-price"))
          label += " \u2014 " + money(match.price);
        submit.textContent = label;
      }

      // keep the URL shareable
      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set("variant", match.id);
        history.replaceState({}, "", url);
      }

      // swap the gallery to this variant's image
      if (match.featured_media_id) {
        var trigger = document.querySelector(
          '[data-media-thumb="' + match.featured_media_id + '"]',
        );
        if (trigger) trigger.click();
      }

      // THE LOAF: light the segments the checked card carries
      var checked = root.querySelector(
        "[data-option-index][data-loaf-segments]:checked",
      );
      if (checked) {
        var n = Number(checked.getAttribute("data-loaf-segments"));
        var segs = Array.prototype.slice.call(
          root.querySelectorAll("[data-loaf-seg]"),
        );
        segs.forEach(function (seg, i) {
          seg.style.transitionDelay = i < n ? i * 60 + "ms" : "0ms";
          seg.classList.toggle("is-on", i < n);
        });
        var countEl = root.querySelector("[data-loaf-count]");
        if (countEl) countEl.textContent = n;
        var countLabelEl = root.querySelector("[data-loaf-count-label]");
        if (countLabelEl)
          countLabelEl.textContent = T.strings.loafOf.replace(
            "[total]",
            segs.length,
          );
        var perEl = root.querySelector("[data-loaf-per]");
        if (perEl)
          perEl.textContent = T.strings.perSoap.replace(
            "[amount]",
            money(Math.round(match.price / n)),
          );
      }
    }

    root.addEventListener("change", function (e) {
      if (e.target.matches("[data-option-index]")) apply();
    });
    apply();
  });

  /* ---------------- sticky add-to-cart ---------------- */

  var sticky = document.querySelector("[data-sticky-atc]");
  var anchor = document.querySelector("[data-atc-anchor]");
  if (sticky && anchor && "IntersectionObserver" in window) {
    new IntersectionObserver(
      function (entries) {
        sticky.classList.toggle("is-visible", !entries[0].isIntersecting);
      },
      { rootMargin: "-120px 0px 0px 0px" },
    ).observe(anchor);
  }

  /* site-wide sticky buy bar: appears once the first screen is behind you */

  var stickyBuy = document.querySelector("[data-sticky-buy]");
  if (stickyBuy) {
    stickyBuy.hidden = false;
    var stickyBuyTicking = false;

    var applyStickyBuy = function () {
      stickyBuyTicking = false;
      var past = window.pageYOffset > window.innerHeight * 0.55;
      stickyBuy.classList.toggle("is-visible", past);
      document.body.classList.toggle("has-sticky-buy", past);
    };

    var stickyVariant = stickyBuy.querySelector("[data-sticky-variant]");
    var stickyPrice = stickyBuy.querySelector("[data-sticky-price]");
    if (stickyVariant && stickyPrice) {
      stickyVariant.addEventListener("change", function () {
        var opt = stickyVariant.options[stickyVariant.selectedIndex];
        var price = opt && opt.getAttribute("data-price");
        if (price) stickyPrice.textContent = price;
      });
    }

    window.addEventListener(
      "scroll",
      function () {
        if (stickyBuyTicking) return;
        stickyBuyTicking = true;
        window.requestAnimationFrame(applyStickyBuy);
      },
      { passive: true },
    );
    applyStickyBuy();
  }

  /* sticky bar button just submits the real form */
  document.addEventListener("click", function (e) {
    var proxy = e.target.closest("[data-atc-proxy]");
    if (!proxy) return;
    e.preventDefault();
    var form = document.querySelector("form[data-cart-form]");
    if (form) form.requestSubmit();
  });

  /* ---------------- accordion: one open at a time ---------------- */

  document.querySelectorAll("[data-acc-exclusive]").forEach(function (group) {
    group.addEventListener(
      "toggle",
      function (e) {
        if (!e.target.open) return;
        group.querySelectorAll("details[open]").forEach(function (d) {
          if (d !== e.target) d.open = false;
        });
      },
      true,
    );
  });

  /* ---------------- motion preference ---------------- */

  var prefersReducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function safePlay(video) {
    var p = video.play();
    if (p && p.catch)
      p.catch(function () {
        /* autoplay refused by the browser — the poster stays up */
      });
  }

  /* the hero film is decoration: under reduced motion it becomes its poster */
  if (prefersReducedMotion) {
    document.querySelectorAll(".hero__video, .ing-film video").forEach(function (video) {
      video.removeAttribute("autoplay");
      video.autoplay = false;
      video.loop = false;
      video.pause();
    });
  }

  /* ---------------- video story (making-of film) ---------------- */

  document.querySelectorAll("[data-video-story]").forEach(function (root) {
    var video = root.querySelector("video");
    if (!video) return;
    var unmute = root.querySelector("[data-video-unmute]");

    if (prefersReducedMotion) {
      video.removeAttribute("autoplay");
      video.autoplay = false;
      video.loop = false;
      video.controls = true;
      video.pause();
    } else {
      safePlay(video);
    }

    if (unmute) {
      unmute.addEventListener("click", function () {
        video.loop = false;
        video.controls = true;
        video.muted = false;
        video.currentTime = 0;
        safePlay(video);
        unmute.hidden = true;
      });
    }

    root.querySelectorAll("[data-video-lang]").forEach(function (chip) {
      chip.addEventListener("click", function () {
        var code = chip.getAttribute("data-video-lang");
        var src = root.getAttribute("data-src-" + code);
        if (!src || video.getAttribute("src") === src) return;
        var wasMuted = video.muted;
        video.setAttribute("src", src);
        video.load();
        video.muted = wasMuted;
        if (!prefersReducedMotion || !wasMuted) safePlay(video);
        root.querySelectorAll("[data-video-lang]").forEach(function (other) {
          other.setAttribute("aria-pressed", String(other === chip));
        });
      });
    });
  });

  /* ---------------- decorative films: retry once the visitor taps ----------------
     iOS refuses muted autoplay in Low Power Mode and under data saver, and the
     rejection is silent: the poster simply stays up. Retry on the first real
     interaction, which counts as a user gesture. */

  if (!prefersReducedMotion) {
    var films = Array.prototype.slice.call(
      document.querySelectorAll(".hero__video, .ing-film video, .vstory__video"),
    );
    var blockedFilms = [];

    films.forEach(function (film) {
      var p = film.play();
      if (p && p.catch) {
        p.catch(function () {
          if (blockedFilms.indexOf(film) < 0) blockedFilms.push(film);
        });
      }
    });

    var retryFilms = function () {
      blockedFilms.forEach(function (film) {
        film.play().catch(function () {});
      });
      blockedFilms = [];
      document.removeEventListener("touchstart", retryFilms);
      document.removeEventListener("click", retryFilms);
      document.removeEventListener("scroll", retryFilms);
    };

    document.addEventListener("touchstart", retryFilms, { passive: true, once: true });
    document.addEventListener("click", retryFilms, { once: true });
    document.addEventListener("scroll", retryFilms, { passive: true, once: true });
  }

  /* ---------------- rail autoplay (one clip at a time) ---------------- */

  document.querySelectorAll("[data-rail-autoplay]").forEach(function (rail) {
    var clips = Array.prototype.slice.call(rail.querySelectorAll("video"));
    if (!clips.length) return;

    /* one tap starts a clip on phones that refuse muted autoplay */
    rail.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-clip-play]");
      if (!btn) return;
      e.preventDefault();
      var card = btn.closest(".rail__card");
      var clip = card && card.querySelector("video");
      if (!clip) return;
      card.classList.remove("is-blocked");
      clip.play().catch(function () {
        card.classList.add("is-blocked");
      });
    });

    if (prefersReducedMotion || !("IntersectionObserver" in window)) return;

    function playClip(clip) {
      var card = clip.closest(".rail__card");
      var p = clip.play();
      if (p && p.catch) {
        p.catch(function () {
          /* autoplay refused: surface the play button instead of a dead poster */
          if (card) card.classList.add("is-blocked");
        });
        if (p.then) {
          p.then(function () {
            if (card) card.classList.remove("is-blocked");
          });
        }
      }
    }

    var ratios = clips.map(function () {
      return 0;
    });

    /*
      Cards are 9:16 and nearly as tall as a phone screen, so their own
      intersectionRatio never reaches the old 0.55 gate on mobile and no clip
      ever started. Score by how much of the VIEWPORT each clip covers instead.
    */
    var railObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var i = clips.indexOf(entry.target);
          if (i < 0) return;
          var box = entry.intersectionRect;
          var visible = box.width * box.height;
          var viewport = window.innerWidth * window.innerHeight;
          var ownRatio = entry.intersectionRatio;
          var viewRatio = viewport ? visible / viewport : 0;
          ratios[i] = Math.max(ownRatio, viewRatio);
        });
        var best = -1;
        var bestRatio = 0;
        ratios.forEach(function (r, i) {
          if (r > bestRatio) {
            bestRatio = r;
            best = i;
          }
        });
        clips.forEach(function (clip, i) {
          if (i === best && bestRatio > 0.2) playClip(clip);
          else if (!clip.paused) clip.pause();
        });
      },
      { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.8, 1] },
    );

    clips.forEach(function (clip) {
      railObserver.observe(clip);
    });
  });

  /* ---------------- initial paint ---------------- */

  fetch(T.routes.cart_url + ".js")
    .then(function (r) {
      return r.json();
    })
    .then(function (cart) {
      updateShipBar(cart.total_price);
    })
    .catch(function () {});
})();
